// Dropping a device's clicker caches, from the device's command menu.
//
// The clicker keeps state between runs that nothing in the panel shows: the phone's own
// account number (so `if_account_cached` skips the CBU detour on every payout after the
// first), the processed-deposit cursors, and the auto task's merchant flag. All three are
// right in production and in the way the moment something has to be re-tested — a flow
// author cannot get back to the "account not known yet" branch without them going away.
//
// Two checkboxes rather than one button because the two halves are not equally safe: the
// account number is re-read on the next pass and costs a detour, while the deposit cursors
// are how the poller knows what it has already credited. So the account cache is ticked by
// default and the deposit state is not.
import { esc, openModal, closeModal, showModalErr } from '../ui/modal';
import { t } from '../ui/lang';
export function showClickerCacheModal(udid, displayName) {
    const modal = openModal(`
        <h2 class="modal__title">${t('clicker.caches_title', { device: esc(displayName) })}</h2>
        <p class="settings-hint">${t('clicker.caches_hint')}</p>
        <div class="modal__field">
            <label class="fe-check"><input type="checkbox" class="cc-account" checked /> ${t('clicker.caches_account')}</label>
            <p class="settings-hint">${t('clicker.caches_account_hint')}</p>
        </div>
        <div class="modal__field">
            <label class="fe-check"><input type="checkbox" class="cc-deposits" /> ${t('clicker.caches_deposits')}</label>
            <p class="settings-hint">${t('clicker.caches_deposits_hint')}</p>
        </div>
        <div class="settings-error modal__error cc-error" style="display:none"></div>
        <div class="modal__actions">
            <button type="button" class="modal__cancel cc-cancel">${t('common.cancel')}</button>
            <button type="button" class="modal__submit cc-go">${t('clicker.caches_clear')}</button>
        </div>
    `);
    const errorEl = modal.querySelector('.cc-error');
    const accountCb = modal.querySelector('.cc-account');
    const depositsCb = modal.querySelector('.cc-deposits');
    const goBtn = modal.querySelector('.cc-go');
    modal.querySelector('.cc-cancel').addEventListener('click', closeModal);
    goBtn.addEventListener('click', async () => {
        // The account cache always goes: the server clears it unconditionally, and a call
        // that clears nothing at all is a button that lies about what it did.
        if (!accountCb.checked && !depositsCb.checked) {
            closeModal();
            return;
        }
        errorEl.style.display = 'none';
        goBtn.disabled = true;
        goBtn.textContent = t('clicker.caches_clearing');
        try {
            const res = await fetch(`/api/devices/${encodeURIComponent(udid)}/clicker-caches`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ deposits: depositsCb.checked }),
            });
            const body = await res.json().catch(() => ({}));
            if (!res.ok) {
                showModalErr(errorEl, body.error ?? t('common.failed_to_save'));
                return;
            }
            closeModal();
        }
        catch {
            showModalErr(errorEl, t('clicker.network_error'));
        }
        finally {
            goBtn.disabled = false;
            goBtn.textContent = t('clicker.caches_clear');
        }
    });
}
